import { LAUNCHPAD_SALE_POOL_TYPE, LaunchpadSalePoolType } from '@api';

import { formatNumberLocalized } from '@shared/helpers/formatters';
import { concatCurrencyToAmount } from '@shared/helpers/formatters/concatCurrencyToAmount';

type PoolTypeMessageFunc = (
  amountFormated: string,
  amountPlusFeeFormated: string,
  feeFormated: string,
) => string;

type OptionalKeys = Extract<LaunchpadSalePoolType, 'SQRP_GATED' | 'PRO_RATA_SQRP_GATED'>;
type RequiredKeys = Exclude<LaunchpadSalePoolType, OptionalKeys>;

const tooltipMessages: Record<RequiredKeys, PoolTypeMessageFunc> &
  Partial<Record<OptionalKeys, PoolTypeMessageFunc>> = {
  [LAUNCHPAD_SALE_POOL_TYPE.FCFS]: (amountFormated, amountPlusFeeFormated, feeFormated) =>
    `
    Your current net allocation will be finalized once the pool closes.
    Your current allocation is ${amountFormated} (calculated as ${amountPlusFeeFormated} minus the ${feeFormated} Fee).
    `,
  [LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA]: (amountFormated, amountPlusFeeFormated, feeFormated) =>
    `
    Your current net allocation will be finalized once the pool closes.
    Your current allocation is ${amountFormated} (calculated as ${amountPlusFeeFormated} minus the ${feeFormated} Fee).
    After the pool closes, any unallocated deposits and fees will be refunded to you.
    `,
};

export const getFeeTooltipMessage = (
  feeCalculatedValue: number,
  amount: number | string,
  currency: string,
  poolType: LaunchpadSalePoolType,
): string => {
  if (!amount) {
    return '';
  }

  const parsedAmount = Number(amount);
  const amountPlusFee = parsedAmount + feeCalculatedValue;

  const feeFormated = concatCurrencyToAmount(feeCalculatedValue, currency);
  const amountPlusFeeFormated = concatCurrencyToAmount(
    formatNumberLocalized(amountPlusFee),
    currency,
  );
  const amountFormated = concatCurrencyToAmount(parsedAmount, currency);

  const createMessage =
    tooltipMessages[poolType] ?? tooltipMessages[LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA];

  return createMessage(amountFormated, amountPlusFeeFormated, feeFormated);
};
